export const MECHANIC_HELP_IDS = [
    'appear',
    'ongoing',
    'death',
    'rush',
    'heat',
    'heats_up',
    'cool',
    'freeze',
    'cannot_cool',
    'shield',
    'token',
    'decay',
    'fragment',
    'assembly',
    'scrap',
    'hack',
    'capture',
    'reaction',
    'virus',
    'cannot_attack',
    'trail',
    'slime_residue',
    'absorb',
    'full_room',
    'multi_hit',
    'dodge',
    'growth',
    'photosynthesis',
    'crown',
    'maturation',
    'thorns',
    'devour',
];
//# sourceMappingURL=types.js.map